module.exports = __webpack_public_path__ + "static/media/calculator.24fb48cb.png";